export var ReportState;
(function (ReportState) {
    ReportState[ReportState["Done"] = 0] = "Done";
    ReportState[ReportState["Ongoing"] = 1] = "Ongoing";
    ReportState[ReportState["AwaitingApproval"] = 2] = "AwaitingApproval";
    ReportState[ReportState["Archived"] = 3] = "Archived";
})(ReportState || (ReportState = {}));
export var ReportSorting;
(function (ReportSorting) {
    ReportSorting[ReportSorting["NewestFirst"] = 0] = "NewestFirst";
})(ReportSorting || (ReportSorting = {}));
